import React, { FC } from 'react';
import { Stack } from '@mui/material';

import { NotificationsSection } from './NotificationsSection';
import { TimeFormatSection } from './TimeFormatSection';
import { LanguageSection } from './LanguageSection';

const GeneralSection: FC = () => {
  return (
    <Stack gap={3} className="general-section">
      <LanguageSection />
      <TimeFormatSection />
      <NotificationsSection />
    </Stack>
  );
};

export default GeneralSection;
